export enum Role {
  Investor = 'investor',
  BusinessOwner = 'business-owner',
  Admin = 'admin',
}
